module.exports = __webpack_public_path__ + "static/media/corri_serious.3b131064.png";